import React, { FunctionComponent } from 'react';

const PendingProcessingIcon: FunctionComponent = () => {
  return (
    <img
      style={{
        width: 'auto',
        height: 'auto',
        maxHeight: '2em',
        maxWidth: '4em',
      }}
      src={require('../../../images/processing@2x.png')}
    />
  );
};
export default PendingProcessingIcon;
